/** @format */

/* eslint-disable */
import React from 'react'
import localize from '../../Global/Localize'
import SimpleLookup from './SimpleLookup'
import { formatDate } from '../../Helpers/formatters'
function RefundTypeLookup({ onSelect, displayValue }) {
  return (
    <SimpleLookup
      title={localize('refundTypeLookup')}
      url="/lookup/RefundType/find-refund-type-by-filter-in-page"
      params={{ filterText: '', pageSize: 10, pageIndex: 0 }}
      columns={[
        {
          label: localize('code'),
          template: r => <>{r.paddedCode}</>,
          sortBy: 'paddedCode',
        },
        {
          label: localize('name'),
          template: r => <>{r.description}</>,
          sortBy: 'description',
        },
        {
          label: localize('transactionOwnership'),
          template: r => <>{r.transactionOwnershipDescription}</>,
        },

        {
          label: localize('recoverSundryArrearages'),
          template: r => (
            <span className="text-capitalize">
              {localize(r.recoverSundryArrearages.toString())}
            </span>
          ),
        },
        {
          label: localize('isLocked'),
          template: r => (
            <span className="text-capitalize">
              {localize(r.isLocked.toString())}
            </span>
          ),
        },
        {
          label: localize('createdDate'),
          template: r => <>{formatDate(r.createdDate, false)}</>,
          sortBy: 'createdDate',
        },
      ]}
      onSelect={onSelect}
      displayValue={displayValue}
    />
  )
}
export default RefundTypeLookup
